const pagesSettingsPermissionAndRolesEn = {
  title: "Permission & Roles",
  common: {
    actions: {
      edit: "Edit",
    },
  },
  productPermissions: {
    filterBarTabs: {
      tabs: {
        ALL: "All",
        // DEPRECATED: "Deprecated",
      },
      actionButtonMenu: {
        create: "Create product permission",
      },
    },
    filterBarButtons: {
      freeText: {
        placeholder: "Filter name...",
      },
    },
    dataTableCard: {
      actionsColumn: {
        deprecate: "Deprecate",
      },
    },
  },
  productPermissionsDetail: {
    basic: {
      title: "Basic",
      productPermissionName: "Name",
      intendedUse: "Intended Use",
    },
    accessibleProducts: {
      title: "Accessible products",
      description: "You can see a list of accessible products.",
    },
    roleUsing: {
      title: "Role using",
      description: "You can see a list of roles using this permission.",
      searchInput: {
        placeholder: "Filter name...",
      },
    },
  },
  createProductPermission: {
    addStepperNavigation: {
      title: {
        create: "Create product permission",
        update: "Update product permission",
      },
      basic: "Basic",
      setPermission: "Set permission",
      reviewTheImpactedRole: "Review the impacted role",
    },
    form: {
      name: "Name",
      namePlaceholder: "XXX Product Permission",
      intendedUse: "Intended use",
      intendedUsePlaceholder: "Describe what this product permission is for.",
      optional: "(Optional)",
      duplicateName:
        "This name is already in use. Please choose a different one.",
    },
    setPermission: {
      title: "Set permission",
      description: "Select the products to enable access.",
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: "Name is required",
      },
      setPermission: {
        permissionRequired: "Permission is required",
      },
    },
    addStepperStepTitleCard: {
      basic: "1. Basic",
      setPermission: "2. Set permission",
      reviewTheImpactedRole: "3. Review the impacted role",
    },
    addStepperCompleteDialog: {
      create: {
        completeMessage: "Product permission created successfully",
        completeLinkButtonText: "Check details",
      },
      update: {
        completeMessage: "Product permission updated successfully",
        completeLinkButtonText: "Check details",
      },
    },
  },
  peopleGroups: {
    title: "People Groups",
    filterBarTabs: {
      tabs: {
        ALL: "All",
        // UNNAMED: "Unnamed",
        // DEPRECATED: "Deprecated",
      },
      actionButtonMenu: {
        create: "Create people group",
      },
    },
    filterBarButtons: {
      freeText: {
        placeholder: "Filter name...",
      },
    },
    dataTableCard: {
      actionsColumn: {
        deprecate: "Deprecate",
      },
      peopleGroupMembershipColumn: {
        rule: {
          workerType: {
            // TODO: common.workerType に統一したい
            EMPLOYEE: "Employee",
            BOARD_MEMBER: "Board Member",
            CONTRACTOR: "Contractor",
            COLLABORATOR: "Collaborator",
          },
        },
      },
    },
  },
  peopleGroupsDetail: {
    basic: {
      title: "Basic",
      groupName: "Name",
      intendedUse: "Intended Use",
      mentionKeyword: "Mention Keyword",
    },
    workerTypeRuleCard: {
      title: "Membership",
      description:
        "Set the conditions for defining people to be included in the People Group.",
    },
    peopleGroupInTheGroupCard: {
      title: "People group in the group",
      searchInput: {
        placeholder: "Filter name...",
      },
    },
  },
  createPeopleGroup: {
    addStepperNavigation: {
      title: {
        create: "Create people group",
        update: "Update people group",
      },
      basic: "Basic",
      setMembership: "Set membership",
      confirmPeopleGroup: "Confirm people group",
      reviewTheImpactedRole: "Review the impacted role",
    },
    addStepperStepTitleCard: {
      basic: "1. Basic",
      setMembership: "2. Set membership",
      confirmPeopleGroup: "3. Confirm people group",
      reviewTheImpactedRole: "4. Review the impacted role",
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: "Name is required",
      },
      setMembership: {
        membershipRequired: "Membership is required",
      },
    },
    form: {
      name: "Name",
      namePlaceholder: "XXX People Group",
      intendedUse: "Intended use",
      intendedUsePlaceholder: "Describe what this people group is for.",
      mentionKeyword: "Mention keyword",
      optional: "(Optional)",
      duplicateName:
        "This name is already in use. Please choose a different one.",
    },
    addStepperCompleteDialog: {
      create: {
        completeMessage: "People group created successfully",
        completeLinkButtonText: "Go to people groups",
      },
      update: {
        completeMessage: "People group updated successfully",
        completeLinkButtonText: "Go to people groups",
      },
    },
    confirmPeopleGroup: {
      filterBarButtons: {
        freeText: {
          placeholder: "Filter name...",
        },
      },
    },
  },
  roles: {
    filterBarTabs: {
      tabs: {
        ALL: "All",
        // DEPRECATED: "Deprecated",
      },
      actionButtonMenu: {
        create: "Create role",
      },
    },
    filterBarButtons: {
      freeText: {
        placeholder: "Filter name...",
      },
    },
  },
  rolesDetail: {
    basic: {
      title: "Basic",
      roleName: "Name",
      intendedUse: "Intended Use",
    },
    peopleGroupDataTableCard: {
      title: "People group",
      description:
        "A People Group defines a group of individuals based on specific conditions. By linking it to a Role, permissions can be managed dynamically.",
    },
    productPermissionDataTableCard: {
      title: "Product permission",
      description:
        "Product permissions define access permit to the products of Dress Code. Depending on the granted permissions, the menu items in the sidebar may change dynamically.",
    },
  },
  createRole: {
    addStepperNavigation: {
      title: {
        create: "Create role",
        update: "Update role",
      },
      basic: "Basic",
      selectPeopleGroup: "Select people group",
      setPermission: "Set permission",
    },
    addStepperStepTitleCard: {
      basic: "1. Basic",
      selectPeopleGroup: "2. Select people group",
      setPermission: "3. Set permission",
    },
    form: {
      name: "Name",
      namePlaceholder: "XXX Role",
      intendedUse: "Intended use",
      intendedUsePlaceholder: "Describe what this role is for.",
      optional: "(Optional)",
      duplicateName:
        "This name is already in use. Please choose a different one.",
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: "Name is required",
      },
      selectPeopleGroup: {
        peopleGroupRequired: "People group is required",
      },
      setPermission: {
        permissionRequired: "Permission is required",
      },
    },
    selectPeopleGroup: {
      title: "Select people group",
      peopleIncluded: "People included",
      searchPlaceholder: "Search people group...",
      noResults: "No results found",
    },
    selectPermission: {
      title: "Select product permission",
      accessibleProducts: "Accessible products",
      searchPlaceholder: "Search product-level access permission...",
      noResults: "No results found",
    },
    addStepperCompleteDialog: {
      create: {
        completeMessage: "Role created successfully",
        completeLinkButtonText: "Go to roles",
      },
      update: {
        completeMessage: "Role updated successfully",
        completeLinkButtonText: "Go to roles",
      },
    },
  },
};

export default pagesSettingsPermissionAndRolesEn;
